import { Info16Regular } from "@fluentui/react-icons";

import { TooltipShort } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

/**
 * InfoHint — kleines Info-Symbol, das seinen Text im Tooltip zeigt.
 *
 * Für erklärende Zusatzinfos, die nicht dauerhaft Platz wegnehmen sollen
 * (z.B. die Beschreibung eines Tags neben dessen Namen). Ohne `text` wird
 * nichts gerendert, der Aufrufer braucht also keine eigene Bedingung.
 *
 * Bewusst ein `<span>` statt `<button>`, damit die Komponente auch innerhalb
 * eines Buttons (z.B. einer Dropdown-Option) gültiges Markup bleibt.
 *
 * @example
 *   <InfoHint text={tag.description} />
 */
export function InfoHint({ text, side = "top", className }) {
  if (!text) return null;
  return (
    <TooltipShort
      side={side}
      label={
        <span className="block max-w-[26rem] whitespace-normal leading-snug">
          {text}
        </span>
      }
    >
      <span
        role="img"
        aria-label={text}
        onClick={(e) => e.stopPropagation()}
        className={cn(
          "inline-flex items-center flex-shrink-0 text-dim",
          "hover:text-foreground transition-colors cursor-help",
          className,
        )}
      >
        <Info16Regular className="w-[1.4rem] h-[1.4rem]" />
      </span>
    </TooltipShort>
  );
}
